/**
 * Newsletter signup right rail widget JS.
 */
// Instantiate components
// Components
import domContentLoaded from '../../js/utils/domContentLoaded';
import reactComponentManager from '../../js/utils/reactComponentManager';
import NewsletterWidget from '../../components/newsletters/components/widget';

domContentLoaded(() => {
  reactComponentManager({
    NewsletterWidget,
  });
});

if (module.hot) {
  module.hot.accept();
  // This is required for HMR, otherwise you'll need to refresh
  // the page to see JS changes

  reactComponentManager({
    NewsletterWidget,
  });
}
